// extracted by mini-css-extract-plugin
export default {"error":"ErrorBoundary-module__error___2gMmR","stack":"ErrorBoundary-module__stack___1yCQG"};